export const FIRM = {
	name: "David Rhee Injury Law",
	legalName: "Law Office of David Rhee, LLC",
	phone: {
		display: "(505) 589-7008",
		href: "tel:+1-505-589-7008",
	},
	fax: {
		display: "(505) 273-8990",
	},
	address: {
		street: "912 6th Street NW",
		city: "Albuquerque",
		state: "New Mexico",
		zip: "87102",
		full: "912 6th Street NW, Albuquerque, New Mexico 87102",
	},
	social: {
		instagram: "https://www.instagram.com/davidrheelaw/",
		googleMaps: "https://maps.app.goo.gl/3DQcq6BQ1VRKBmNQA",
	},
};
